import React, { useState } from 'react'
import { Button, Card, DatePicker, Space, Typography, message } from 'antd'
import { getConversationStats } from 'api/dashboard/getConversationStats'
import { Moment } from 'moment'
import { Pie } from '@ant-design/plots'
import { RangeValue } from 'rc-picker/lib/interface'
import style from './style.module.scss'

interface PropType {
	clientId?: string
}
interface ConversationStatsType {
	billingType: string
	count: number
}

const { Text } = Typography

const ConversationStatsCard: React.FC<PropType> = ({ clientId }) => {
	const [stats, setStats] = useState<ConversationStatsType[]>([])
	const [dateRange, setDateRange] = useState<RangeValue<Moment>>(null)
	const [loading, setLoading] = useState(false)
	const [hasFetched, setHasFetched] = useState(false)

	const fetchStats = async () => {
		if (!dateRange?.[0] || !dateRange?.[1]) {
			message.warning('Select a start and end date')
			return
		}

		setLoading(true)

		try {
			const response = await getConversationStats({
				startDate: dateRange[0].startOf('D').toJSON(),
				endDate: dateRange[1].endOf('D').toJSON(),
				client: clientId,
			})

			const data = Object.entries(response).map(d => ({
				billingType: d[0],
				count: d[1],
			}))

			setStats(data)
			setHasFetched(true)
		} catch {
			setHasFetched(false)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Card title='UIC And BIC Stats' className={style.layout}>
			<Space wrap>
				<DatePicker.RangePicker
					format='YYYY-MM-DD'
					value={dateRange}
					onChange={setDateRange}
					disabledDate={current => current.valueOf() > Date.now()}
					disabled={loading}
				/>
				<Button type='primary' onClick={fetchStats} loading={loading}>
					Apply
				</Button>
			</Space>
			{!hasFetched && !loading && (
				<Text type='secondary'>
					Select a date range and click Apply to load stats.
				</Text>
			)}
			<div className={style.position}>
				<Pie
					appendPadding={50}
					data={hasFetched ? stats : []}
					angleField='count'
					colorField='billingType'
					radius={0.8}
					label={{
						type: 'spider',
						labelHeight: 50,
						content: '{name}\n{percentage}',
						autoRotate: false,
					}}
					interactions={[
						{
							type: 'element-selected',
						},
						{
							type: 'element-active',
						},
					]}
					loading={loading}
				/>
			</div>
		</Card>
	)
}
ConversationStatsCard.defaultProps = {
	clientId: undefined,
}
export default ConversationStatsCard
